<template>
  <div class="card mt-3">
    <div class="card-body">
      <h5 class="card-title">
        {{ trans("admin.cdr.verificationChecklist") }}
      </h5>

      <div class="form-check mb-2">
        <input
          id="verify-authorised"
          v-model="checks.authorisedRepresentative"
          class="form-check-input"
          type="checkbox"
        />
        <label class="form-check-label" for="verify-authorised">
          {{ trans("admin.cdr.verifyAuthorisedRepresentative") }}
        </label>
      </div>

      <div class="form-check mb-2">
        <input
          id="verify-identity"
          v-model="checks.identityValidated"
          class="form-check-input"
          type="checkbox"
        />
        <label class="form-check-label" for="verify-identity">
          {{ trans("admin.cdr.verifyIdentityValidated") }}
        </label>
      </div>

      <div class="form-check mb-3">
        <input
          id="verify-scope"
          v-model="checks.scopeDefined"
          class="form-check-input"
          type="checkbox"
        />
        <label class="form-check-label" for="verify-scope">
          {{ trans("admin.cdr.verifyScopeDefinition") }}
        </label>
      </div>

      <button
        type="button"
        class="btn btn-primary"
        :disabled="!allChecked || submitting"
        @click="submit"
      >
        {{ trans("admin.cdr.verifyConfirm") }}
      </button>
    </div>
  </div>
</template>

<script>
import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";

export default {
  props: {
    flag: { type: Object, required: true },
    apiUrl: { type: String, required: true },
  },
  emits: ["updated"],
  data() {
    return {
      submitting: false,
      checks: {
        authorisedRepresentative: false,
        identityValidated: false,
        scopeDefined: false,
      },
    };
  },
  computed: {
    allChecked() {
      return (
        this.checks.authorisedRepresentative &&
        this.checks.identityValidated &&
        this.checks.scopeDefined
      );
    },
  },
  methods: {
    submit() {
      this.submitting = true;
      practitionerHttpService
        .put(this.apiUrl + this.flag.id + "/verify", {
          authorised_representative: true,
          identity_validated: true,
          scope_defined: true,
        })
        .then((res) => {
          this.submitting = false;
          this.$emit("updated", res.data);
        })
        .catch((error) => {
          this.submitting = false;
          this.userErrorMessage(error);
        });
    },
  },
};
</script>
